import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';

import Home from './components/Home'
import Gallery from './components/Gallery'
import Contact from './components/Contact'
import Services from './components/Services'

import './style.css';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '*', component: Home, name: 'home' },
    { path: '/gallery/:name', component: Gallery, name: 'gallery' },
    { path: '/contact', component: Contact, name: 'contact' },
    { path: '/services', component: Services, name: 'services' }
  ]
});

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
